import React, { useState } from 'react';
import { LayoutTemplate, Image, Type, Link as LinkIcon, Save, Plus } from 'lucide-react';
type CmsSection = 'hero' | 'featured' | 'about' | 'footer';
export const CmsManagement = () => {
  const [activeSection, setActiveSection] = useState<CmsSection>('hero');
  const sections: Array<{
    key: CmsSection;
    label: string;
    icon: any;
  }> = [{
    key: 'hero',
    label: 'Homepage Hero',
    icon: LayoutTemplate
  }, {
    key: 'featured',
    label: 'Featured Properties',
    icon: Image
  }, {
    key: 'about',
    label: 'About Page Content',
    icon: Type
  }, {
    key: 'footer',
    label: 'Footer Links',
    icon: LinkIcon
  }];
  return <div className="space-y-6 animate-in fade-in" data-id="element-524">
      <div className="flex justify-between items-center" data-id="element-525">
        <div data-id="element-526">
          <h1 className="text-2xl font-serif font-bold text-slate-900 dark:text-white mb-1" data-id="element-527">
            CMS Management
          </h1>
          <p className="text-slate-500 dark:text-slate-400" data-id="element-528">
            Manage website content, banners, and featured sections.
          </p>
        </div>
        <button className="px-4 py-2 bg-secondary hover:bg-secondary-dark text-primary-900 font-bold rounded-lg flex items-center gap-2 transition-colors" data-id="element-529">
          <Save size={18} data-id="element-530" /> Publish Changes
        </button>
      </div>

      <div className="grid lg:grid-cols-3 gap-6" data-id="element-531">
        {/* Left Col: Navigation */}
        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-4 h-fit" data-id="element-532">
          <div className="space-y-1" data-id="element-533">
            {sections.map(section => {
            const SectionIcon = section.icon;
            const isActive = activeSection === section.key;
            return <button key={section.key} onClick={() => setActiveSection(section.key)} className={`w-full text-left px-4 py-3 rounded-xl font-medium flex items-center gap-3 transition-colors ${isActive ? 'bg-slate-100 dark:bg-slate-800 text-slate-900 dark:text-white font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-white'}`} data-id="element-534">
                  <SectionIcon size={18} className={isActive ? 'text-secondary' : ''} data-id="element-535" />{' '}
                  {section.label}
                </button>;
          })}
          </div>
        </div>

        {/* Right Col: Editor */}
        <div className="lg:col-span-2 space-y-6" data-id="element-536">
          {activeSection === 'hero' && <>
              <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-537">
                <h2 className="text-lg font-bold text-slate-900 dark:text-white mb-6" data-id="element-538">
                  Homepage Hero Section
                </h2>

                <div className="space-y-6" data-id="element-539">
                  <div data-id="element-540">
                    <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-541">
                      Headline
                    </label>
                    <input type="text" defaultValue="Verified Abuja Real Estate Without Middlemen" className="w-full px-4 py-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white focus:ring-2 focus:ring-secondary outline-none" data-id="element-542" />
                  </div>

                  <div data-id="element-543">
                    <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-544">
                      Subheadline
                    </label>
                    <textarea rows={3} defaultValue="Discover verified land and property listings directly from trusted owners and authorized sellers." className="w-full px-4 py-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white focus:ring-2 focus:ring-secondary outline-none resize-none" data-id="element-545" />
                  </div>

                  <div data-id="element-546">
                    <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-547">
                      Background Image
                    </label>
                    <div className="border-2 border-dashed border-slate-300 dark:border-slate-600 rounded-xl p-8 flex flex-col items-center justify-center text-center hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors cursor-pointer" data-id="element-548">
                      <Image size={32} className="text-slate-400 dark:text-slate-500 mb-3" data-id="element-549" />
                      <h4 className="font-bold text-slate-700 dark:text-slate-300 mb-1" data-id="element-550">
                        Upload New Image
                      </h4>
                      <p className="text-xs text-slate-500" data-id="element-551">
                        1920x1080px recommended. JPG or PNG.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-552">
                <div className="flex justify-between items-center mb-6" data-id="element-553">
                  <h2 className="text-lg font-bold text-slate-900 dark:text-white" data-id="element-554">
                    Hero CTA Buttons
                  </h2>
                  <button className="text-secondary text-sm font-bold flex items-center gap-1 hover:text-secondary-dark" data-id="element-555">
                    <Plus size={16} data-id="element-556" /> Add Button
                  </button>
                </div>

                <div className="space-y-4" data-id="element-557">
                  <div className="flex gap-4 items-center p-4 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700" data-id="element-558">
                    <div className="flex-grow" data-id="element-559">
                      <label className="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-1" data-id="element-560">
                        Label
                      </label>
                      <input type="text" defaultValue="Explore Properties" className="w-full px-3 py-2 rounded-lg bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white text-sm outline-none" data-id="element-561" />
                    </div>
                    <div className="flex-grow" data-id="element-562">
                      <label className="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-1" data-id="element-563">
                        Link
                      </label>
                      <input type="text" defaultValue="/explore" className="w-full px-3 py-2 rounded-lg bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white text-sm outline-none" data-id="element-564" />
                    </div>
                    <div className="pt-5" data-id="element-565">
                      <button className="p-2 text-red-500 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-500/10 rounded-lg transition-colors" data-id="element-566">
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>}

          {activeSection === 'featured' && <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-567">
              <h2 className="text-lg font-bold text-slate-900 dark:text-white mb-6" data-id="element-568">
                Featured Properties
              </h2>
              <p className="text-sm text-slate-500 dark:text-slate-400 mb-6" data-id="element-569">
                Select which properties to feature on the homepage carousel.
              </p>
              <div className="space-y-3" data-id="element-570">
                {['Luxury 5-Bed Duplex — Maitama', '3-Bed Apartment — Wuse 2', 'Commercial Plot — Central Area', 'Detached Bungalow — Gwarinpa'].map((item, i) => <label key={i} className="flex items-center justify-between p-4 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700/50 transition-colors" data-id="element-571">
                    <span className="text-sm font-medium text-slate-900 dark:text-white" data-id="element-572">
                      {item}
                    </span>
                    <input type="checkbox" defaultChecked={i < 3} className="rounded border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 text-secondary focus:ring-secondary" data-id="element-573" />
                  </label>)}
              </div>
            </div>}

          {activeSection === 'about' && <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-574">
              <h2 className="text-lg font-bold text-slate-900 dark:text-white mb-6" data-id="element-575">
                About Page Content
              </h2>
              <div className="space-y-6" data-id="element-576">
                <div data-id="element-577">
                  <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-578">
                    Mission Statement
                  </label>
                  <textarea rows={4} defaultValue="AMU exists to bring trust, transparency, and verified ownership to Abuja's real estate market." className="w-full px-4 py-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white focus:ring-2 focus:ring-secondary outline-none resize-none" data-id="element-579" />
                </div>
                <div data-id="element-580">
                  <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-581">
                    Company Story
                  </label>
                  <textarea rows={6} defaultValue="Founded in 2023, AMU partners with AGIS and FCDA to verify every listing..." className="w-full px-4 py-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white focus:ring-2 focus:ring-secondary outline-none resize-none" data-id="element-582" />
                </div>
              </div>
            </div>}

          {activeSection === 'footer' && <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-583">
              <div className="flex justify-between items-center mb-6" data-id="element-584">
                <h2 className="text-lg font-bold text-slate-900 dark:text-white" data-id="element-585">
                  Footer Links
                </h2>
                <button className="text-secondary text-sm font-bold flex items-center gap-1 hover:text-secondary-dark" data-id="element-586">
                  <Plus size={16} data-id="element-587" /> Add Link
                </button>
              </div>
              <div className="space-y-3" data-id="element-588">
                {[{
              label: 'Terms & Conditions',
              url: '/terms'
            }, {
              label: 'Privacy Policy',
              url: '/privacy'
            }, {
              label: 'Verification Process',
              url: '/verification'
            }, {
              label: 'Fraud Prevention',
              url: '/fraud-prevention'
            }].map((link, i) => <div key={i} className="flex gap-4 items-center p-4 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700" data-id="element-589">
                    <input type="text" defaultValue={link.label} className="flex-grow px-3 py-2 rounded-lg bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white text-sm outline-none" data-id="element-590" />
                    <input type="text" defaultValue={link.url} className="flex-grow px-3 py-2 rounded-lg bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white text-sm outline-none" data-id="element-591" />
                    <button className="p-2 text-red-500 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-500/10 rounded-lg transition-colors" data-id="element-592">
                      Remove
                    </button>
                  </div>)}
              </div>
            </div>}
        </div>
      </div>
    </div>;
};